export const SET_STATUS="app/operators/SET_STATUS"
export const NEXT_PAGE="app/operators/NEXT_PAGE"
export const BACK_PAGE="app/operators/BACK_PAGE"
export const RESET_PAGE="app/operators/RESET_PAGE"
export const OPERATORS_LOADING="app/operators/OPERATORS_LOADING"
export const SET_SEARCH="app/operators/SET_SEARCH"
export const SET_SEARCH_VIEW="app/operators/SET_SEARCH_VIEW"
